import { makeStyles } from '@material-ui/core/styles';

// export const strokeWidthOfLine = 2;
export const strokeWidthOfLine = 2;


const useStyles = makeStyles((theme) => ({
  reactflowWrapper: () => ({
    flexGrow: 1,
    height: `calc(100vh - ${theme.mixins.toolbar.height})`,
    width: '100%',
  }),
  reactWrapper: () => ({
    height: `calc(100vh - ${theme.mixins.toolbar.height * 2})`,
    width: '100%',
  }),
  controlsPosition: {
    // right: '0 !important',
    // zIndex: '1 !important',
  },
}));

export default useStyles;

export const nodeElementWidth = 200;

export const generateNodeStyle = (key, extraStyle = {}) => {
  //const commonStyle = { height: 50, width: nodeElementWidth, padding: 4, border: '1px solid #1a192b', borderRadius: 2, marginBottom: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'grab', ...extraStyle };
  const commonStyle = { padding: 4, borderRadius: 2, marginBottom: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'grab', ...extraStyle };

  const styles = {
    clusterlet: { style: { ...commonStyle, background: `url(${process.env.PUBLIC_URL}/node_icons/ide_digital_twin.png) 50% 50% / 90px 83px no-repeat`, width: 90, height: 83 } },
    external_function: { style: { ...commonStyle, background: `url(${process.env.PUBLIC_URL}/node_icons/ide_delegate.png) 50% 50% / 108px 108px no-repeat`, color: '#000', border: 'none', width: 120, height: 120 } },
    sensor: { style: { ...commonStyle, background: `url(${process.env.PUBLIC_URL}/node_icons/ide_sensor.png) 50% 50% / 90px 90px no-repeat`, color: '#fff', border: 'none', height: 90, width: 90 } },
    profile: { style: { ...commonStyle, backgroundColor: '#6AE11E', color: '#000' } },
    section: { style: { ...commonStyle, backgroundColor: '#f5f5f5', color: '#000' } },
    analytics: { style: { ...commonStyle, width: 90, height: 83, background: `url(${process.env.PUBLIC_URL}/node_icons/ide_analytics.png) 50% 50% / 90px 83px no-repeat`, color: '#fff' } },
    user: { style: { ...commonStyle, background: `url(${process.env.PUBLIC_URL}/node_icons/ide_sensor.png) 50% 50% / 90px 90px no-repeat`, color: '#fff', border: 'none', height: 90, width: 90 } },
    label_node: { style: { ...commonStyle, backgroundColor: 'transparent', color: '#000', } },
    templated_clusterlet: { style: { ...commonStyle, width: 170, height: 70, backgroundColor: '#d9ba9c', color: '#000' } },
    controller_delegate: { style: { ...commonStyle, backgroundColor: '#fff', color: '#000', border: 'none', height: '50px', width: '150px', border: '1px solid #000' } },
    template_delegate: { style: { ...commonStyle, backgroundColor: '#transparent', color: '#000', border: 'none' } },
  };

  return styles[key] || commonStyle;
};
